export enum HumanAuthorities {
    ROLE_SUPER_ADMIN,
    ROLE_ADMIN,
    ROLE_STAFF,
    ROLE_USER
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/enums/human-authorities.enum.ts